import { Backup, Layout } from '../components';

const BackupPage = () => {
  return (
    <Layout>
      <Backup />
    </Layout>
  );
};

export default BackupPage;
